// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__RD0z1","top":"styles_top__1dfQF"};